<div class="points-background bg-glass-dark">
  <span class="material-icons align-middle fw-bold text-white">loyalty</span>

  <span class="fw-bold text-white">{{ pointsBalance$ | async | number: '1.0' }}</span>
</div>
